import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { _className, ComponentSync } from '@nu-art/thunderstorm-frontend/index';
import { ICONS } from '@app/styles';
import { ModuleFE_Discussion } from '@app/hcs-frontend';
import { ModuleFE_AppModule } from '../../../../modules/app-module/ModuleFE_AppModule.js';
export class Component_DiscussionButton extends ComponentSync {
    __onDiscussionsUpdated(...params) {
        this.reDeriveState();
    }
    deriveStateFromProps(nextProps, state) {
        state.unresolvedDiscussions = ModuleFE_Discussion.cache.all().some(discussion => discussion.status !== 'resolved');
        return state;
    }
    getEnvString() {
        switch (ModuleFE_AppModule.getEnv()?.toLowerCase()) {
            case 'local':
                return 'local';
            case 'dev':
                return 'dev';
            case 'staging':
                return 'staging';
            default:
                return '';
        }
    }
    render() {
        return _jsxs("div", { className: 'container-discussions-button', children: [_jsx(ICONS.messageBubble.component, { className: 'discussions-button', onClick: () => {
                        this.logInfo('Clicked on DiscussionsView button');
                        ModuleFE_Discussion.openDiscussions({});
                    } }), this.state.unresolvedDiscussions &&
                    _jsx("div", { className: _className('there-are-unresolved-discussions', this.getEnvString()) })] });
    }
}
